/**
 * Banner file pixel size (crop dialog export and recommended upload).
 * Height 280 fits square / tall artwork better than the old 200px strip.
 */

export const BANNER_EXPORT_WIDTH = 800;
export const BANNER_EXPORT_HEIGHT = 280;

/** Profile / avatar crop export (matches CardCustomizer recommendation). */
export const PROFILE_EXPORT_WIDTH = 400;
export const PROFILE_EXPORT_HEIGHT = 400;
